import {match} from 'ts-pattern';

import type {CustomerMessageResponseBody} from '@dms/api/core';

const DELIVERED_MESSAGE_STATE = 'sent';
const CONNECTED_CALL_OUTCOME = 'connected';

const getCreatedAtTime = (message: CustomerMessageResponseBody) => Date.parse(message.createdAt); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

const isEligibleCustomerMessage = (message: CustomerMessageResponseBody) =>
  Number.isFinite(getCreatedAtTime(message)) &&
  (message.channel === 'call'
    ? message.call?.outcome === CONNECTED_CALL_OUTCOME
    : match(message.direction)
        .with('OUTGOING', () => message.state === DELIVERED_MESSAGE_STATE)
        .with('INCOMING', () => true)
        .exhaustive());

export const getNewestEligibleCustomerMessage = (
  messages: CustomerMessageResponseBody[] | undefined
) =>
  messages
    ?.filter(isEligibleCustomerMessage)
    .reduce<
      CustomerMessageResponseBody | undefined
    >((newest, message) => (newest === undefined || getCreatedAtTime(message) > getCreatedAtTime(newest) ? message : newest), undefined);
